import { useQuery } from '@tanstack/react-query';
import { MaterialCategory, CategoryType } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';

export const MATERIAL_CATEGORIES_QUERY_KEY = ['materialCategories'];

export const useMaterialCategories = () => {
  return useQuery<MaterialCategory[], Error>({
    queryKey: MATERIAL_CATEGORIES_QUERY_KEY,
    queryFn: async () => {
      const categories = await warehouseService.getMaterialCategories();
      return categories || [];
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - categories change rarely
  });
};

export const useMaterialCategoriesByType = (type: CategoryType) => {
  return useQuery<MaterialCategory[], Error>({
    queryKey: [...MATERIAL_CATEGORIES_QUERY_KEY, 'byType', type],
    queryFn: async () => {
      const categories = await warehouseService.getMaterialCategoriesByType(type);
      return categories || [];
    },
    staleTime: 10 * 60 * 1000,
  });
};

export default useMaterialCategories;
